import Container from './Container';
import CreateForm from './CreateForm';
import DeleteDomainSection from './DeleteDomainSection';
import DomainStatusSection from './DomainStatusSection';
import LinkTrackingDomainSection from './LinkTrackingDomainSection';
import SendingAndBounceDomainSection from './SendingAndBounceDomainSection';
import SendingDomainsTab from './SendingDomainsTab';
import SendingDomainsTable from './SendingDomainsTable';
import SetupBounceDomainSection from './SetupBounceDomainSection';
import SetupForSending from './SetupForSending';
import TlsStatusBadge from './TlsStatusBadge';
import TrackingDnsSection from './TrackingDnsSection';
import TrackingDomainsTab from './TrackingDomainsTab';
import TrackingDomainsTable from './TrackingDomainsTable';
import TrackingDomainStatusCell from './TrackingDomainStatusCell';
import TrackingDomainTLSCertificateSection from './TrackingDomainTLSCertificateSection';
import VerifyEmailSection from './VerifyEmailSection';

export default {
  CreateForm,
  Container,
  SendingDomainsTab,
  TrackingDomainsTab,
  SendingDomainsTable,
  TrackingDomainsTable,
  SetupForSending,
  SetupBounceDomainSection,
  SendingAndBounceDomainSection,
  DeleteDomainSection,
  DomainStatusSection,
  LinkTrackingDomainSection,
  VerifyEmailSection,
  TrackingDomainStatusCell,
  TrackingDnsSection,
  TrackingDomainTLSCertificateSection,
  TlsStatusBadge
};
